module.exports = __webpack_public_path__ + "static/media/VERSAJETFVJ.67da789a.jpg";